import React, { FC } from 'react';
import { Col, Row } from 'antd';
import { ExpertiseComponentContainer, FormContainer, FormItem } from '../../../../styles/styled';
import { ExpertiseType } from '../../../ExpertisePage/types';

type MainInfoComponentProps = {
  expertise?: ExpertiseType;
};

export const MainInfoComponent: FC<MainInfoComponentProps> = ({ expertise }) => {
  return (
    <ExpertiseComponentContainer>
      <FormContainer padding="25px" background={'#ffffff'}>
        <Row gutter={[20, 20]}>
          <Col span={24}>
            <FormItem>
              <div className="text">Авторы</div>
              <div className="dark-text">{expertise?.textbook.author}</div>
            </FormItem>
          </Col>
          <Col span={24}>
            <FormItem>
              <div className="text">Издательство</div>
              <div className="dark-text">{expertise?.textbook?.publisher?.title}</div>
            </FormItem>
          </Col>
          <Col span={24}>
            <FormItem>
              <div className="text">Правообладатель</div>
              <div className="dark-text">{expertise?.textbook?.publisher?.title}</div>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem>
              <div className="text">Год издания</div>
              <div className="dark-text">{expertise?.textbook?.year}</div>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem>
              <div className="text">Язык издания</div>
              <div className="dark-text">{expertise?.textbook?.language?.title}</div>
            </FormItem>
          </Col>
        </Row>
      </FormContainer>
    </ExpertiseComponentContainer>
  );
};
